  <div class="editor-choice-highlight-card" *ngIf="editorChoiceSlideContent.product_type === productType.ARTICLE">
    <div class="p-3 editor-choice-highlight-heading paragraph-bold">
      <img src="assets/themes/icons/references-icon.svg" class="mr-2 editor-choice-highlight-logo" alt="Card Icon" />
      {{editorChoiceSlideContent.editor_choice_data.ec_product_header_text}}
    </div>
    <ng-container *ngTemplateOutlet="productMaskingContainer"></ng-container>
    <div class="px-3 py-2" >
      <span class="cursor-pointer" (click)="fcs.navigateToJournalDetail(editorChoiceSlideContent.id, ecId);setAnalyticsSdkObjectOnClick('REFERENCE', 'CARD')">
      <div class="mb-3">
        <img [src]="(editorChoiceSlideContent.banner) | fitInImg :igs.imageGroup.fitin_500x500"
          onerror="this.src='assets/themes/images/banner-placeholder-lg.svg'" alt="Banner"
          class="editor-card-highlight-card-banner w-100 post-pic" />
      </div>
      <p class="editor-card-highlight-title secondary-paragraph">
        <span class="font-weight-bold">{{editorChoiceSlideContent.title}}</span>
      </p>
      <div class="mt-2 primary-small specialty-content">
        <ng-container *ngIf="editorChoiceSlideContent.categories.length>0">
          <span *ngFor="let category of editorChoiceSlideContent.categories | slice: 0:3; let i = index"
            class="mr-2 color-grey-500 cursor-pointer d-inline-block">
            <span (click)="getSpecialty(category)">
              #{{category?.category_name}}{{i === 2 ? '...' : ''}}
            </span>
          </span>
        </ng-container>
      </div>
      <div *ngIf="editorChoiceSlideContent.channel" class="d-flex align-items-center mt-2">
        <span class="highlight-card-logo-container">
          <img
            [src]="editorChoiceSlideContent.channel.channel_logo"
            class="highlight-card-logo"
            onerror="this.src='assets/themes/icons/channels-logo-placeholder.svg'"
            alt="Publication logo" />
        </span>
        <span class="primary-small ml-2 pl-1">
          <span class="color-grey-700">{{editorChoiceSlideContent.channel.title}}</span>
        </span>
      </div>
      </span>
      <div class="highlight-like-views py-2 secondary-paragraph"
       *ngIf="editorChoiceSlideContent.like_count || editorChoiceSlideContent.total_views">
        <span class="dot-creation mr-4 color-grey-500" *ngIf="editorChoiceSlideContent.like_count>0">
          {{editorChoiceSlideContent.like_count}}
          {{editorChoiceSlideContent.like_count | likeOrLikesText}}
        </span>
        <span class="color-grey-500" *ngIf="editorChoiceSlideContent.total_views>0">
          {{editorChoiceSlideContent.total_views}} {{nls.languageText.clinical_resource_card.key12}}
        </span>
      </div>
    </div>
  </div>
  
  <div class="editor-choice-highlight-card" *ngIf="editorChoiceSlideContent.product_type === productType.FEED">
    <div class="p-3 editor-choice-highlight-heading paragraph-bold">
      <img src="assets/themes/icons/gr/clinical-case.svg" class="mr-2 editor-choice-highlight-logo" alt="Card Icon" />
      {{editorChoiceSlideContent.editor_choice_data.ec_product_header_text}}
    </div>
    <ng-container *ngTemplateOutlet="productMaskingContainer"></ng-container>
    <div class="p-3">
      <span class="cursor-pointer" (click)="fcs.navigateToFeedDetail(editorChoiceSlideContent.feed_id, ecId);setAnalyticsSdkObjectOnClick('FEED', 'CARD')">
      <div *ngIf="editorChoiceSlideContent.media_list[0]" class="mb-2 position-relative">
        <img  [src]="(editorChoiceSlideContent.media_list[0].media_type === mediaType.IMAGE
            ? editorChoiceSlideContent.media_list[0].media_url
            : editorChoiceSlideContent.media_list[0].media_thumbnail) | fitInImg :igs.imageGroup.fitin_500x500"
          onerror="this.src='assets/themes/images/banner-placeholder-lg.svg'" alt="Banner"
          class="editor-card-highlight-card-banner w-100 post-pic" />
        <img *ngIf="editorChoiceSlideContent.media_list[0].media_type === mediaType.VIDEO"
          src="assets/themes/icons/filled-play-icon.svg" class="play-icon" />
      </div>
      <div *ngIf="!editorChoiceSlideContent.media_list[0]" class=" mb-2">
        <img [src]="('assets/themes/images/banner-placeholder-lg.svg') | fitInImg :igs.imageGroup.fitin_500x500"
          alt="Banner"
          class="editor-card-highlight-card-banner w-100 post-pic" />
      </div>
      <div *ngIf="editorChoiceSlideContent.user_profile" class="d-flex align-items-center mt-3"
       (click)="fcs.stopEventPropagation(); navigateToUser(editorChoiceSlideContent.user_profile)">
        <span class="highlight-card-logo-container mr-2 float-left">
          <img
            [src]="editorChoiceSlideContent.user_profile.profile_pic"
            class="highlight-card-logo "
            onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'"
            alt="Profile pic" />
        </span>
        <div >
          <p class="editor-card-highlight-title paragraph-bold">
            <span class="color-gery-700">{{editorChoiceSlideContent.user_profile.full_name}}</span></p>
          <span class="secondary-paragraph" *ngFor="let specialty of editorChoiceSlideContent.user_profile.specialities">
            <span class="color-grey-700">{{specialty.speciality_name}}</span>
          </span>
        </div>
      </div>
      <div *ngIf="!editorChoiceSlideContent.user_profile && editorChoiceSlideContent.channel" class="d-flex align-items-center clearfix mt-3" (click)="fcs.stopEventPropagation(); navigateToChannel(editorChoiceSlideContent.channel)">
        <span class="highlight-card-logo-container mr-2 float-left">
          <img
            [src]="editorChoiceSlideContent.channel.channel_logo"
            class="highlight-card-logo "
            onerror="this.src='assets/themes/icons/channels-logo-placeholder.svg'"
            alt="Logo" />
        </span>
        <div class="ec-highlight-card__profile-detail p-0">
          <p class="paragraph-bold">{{editorChoiceSlideContent.channel.title}}</p>
          <div class="primary-small"><p class="color-grey-700">
            {{editorChoiceSlideContent.channel.powered_by_label}}
            {{editorChoiceSlideContent.channel.powered_name}}
          </p></div>
        </div>
      </div>
      <p class="editor-card-highlight-title secondary-paragraph my-2">
        {{editorChoiceSlideContent.content}}
      </p>
      </span>
      <div *ngIf="editorChoiceSlideContent.total_like>0 || editorChoiceSlideContent.total_comments>0" class="highlight-like-views primary-small py-2 secondary-paragraph">
        <span class="mr-4 color-grey-500" [ngClass]="{'dot-creation':editorChoiceSlideContent.total_comments>0}" *ngIf="editorChoiceSlideContent.total_like>0">
          {{editorChoiceSlideContent.total_like}}
          {{editorChoiceSlideContent.total_like | likeOrLikesText}}
        </span>
        <span class="color-grey-500" *ngIf="editorChoiceSlideContent.total_comments>0">
          {{editorChoiceSlideContent.total_comments}} {{nls.languageText.clinical_resource_card.key11}}
        </span>
      </div>
    </div>
  </div>
  
  
  <ng-template #productMaskingContainer>
    <div class="position-absolute w-100 h-100 masking-div"
      *ngIf="(editorChoiceSlideContent?.channel?.content_visibility?.display === numbers.ZERO || editorChoiceSlideContent?.channel?.content_visibility?.display === numbers.TWO)">
      <app-product-masking-card 
       [content_visibility]="editorChoiceSlideContent?.channel.content_visibility">
      </app-product-masking-card>
    </div>
  </ng-template>